export enum GatewayRequestType {
  Login = 'Login',
  Ping = 'Ping',

  GetLatestNewsArticlesBySymbols = 'GetLatestNewsArticlesBySymbols',
  GetLatestNewsArticles = 'GetLatestNewsArticles',
  MarketDataSubscribeNbbo = 'MarketDataSubscribeNbbo',
  MarketDataSubscribeTrade = 'MarketDataSubscribeTrade',
  FXSubscription = 'FxQuoteDataSubscribe',
  AugFXSubscription = 'AugFxQuoteDataSubscribe',
  FxQuoteDataSummary = 'FxQuoteDataSummary',
  MarketDataSummary = 'MarketDataSummary',
  InstrumentSnapshot = 'InstrumentSnapshot',
  MarketDataSubscribeSymbolStatus = 'MarketDataSubscribeSymbolStatus',

  // unsubscribe
  MarketDataUnsubscribeSymbolStatus = 'MarketDataUnsubscribeSymbolStatus',
  MarketDataUnsubscribeNbbo = 'MarketDataUnsubscribeNbbo',
  MarketDataUnsubscribeTrade = 'MarketDataUnsubscribeTrade',
  FXUnsubscription = 'FxQuoteDataUnsubscribe',
  AugFXUnsubscription = 'AugFxQuoteDataUnsubscribe',

  None = '',
}

export enum GatewayResponseType {
  Login = 'Login',
  DataSummaryResponse = 'DataSummaryResponse',
  DataQueryResponse = 'DataQueryResponse',
  InstrumentSnapshot = 'InstrumentSnapshot',
  Subscriptions = 'Subscriptions',
  Pong = 'Pong',
  MarketData = 2,
  FXSubscription = 4,
}

export enum GatewayResponseSubType {
  Trade = 3,
  Nbbo = 5,
  FxQuote = 10,
  AugFxQuote = 21,
  SymbolStatus = 14
}
